import React from 'react';
import { useAppState } from '../App/AppContext';
import { EditBookForm } from '../Book/EditBookForm';
import { BookComponent } from '../Book/BookComponent';
import { Book } from '../Book/types';
import { db } from '../firebase';
import { isAdmin } from '../utils';
import {
  Container,
  Dropdown,
  Grid,
  Input,
  Menu,
  Segment,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export const Component = () => {
  const [books, setBooks] = React.useState<Book[]>([]);
  const [search, setSearch] = React.useState<string>();
  const [editId, setEditId] = React.useState<string>();
  const [selectedGenres, setSelectedGenres] = React.useState<string[]>([]);

  const { user } = useAppState();

  const fetchBooks = () => {
    db.collection('books')
      .get()
      .then((querySnapshot) => {
        const resp: Book[] = [];
        querySnapshot.forEach((doc) => {
          resp.push({
            id: doc.id,
            name: doc.data().name,
            picture: doc.data().picture,
            available: doc.data().available,
            author: doc.data().author,
            genre: doc.data().genre,
          });
        });
        setBooks(resp);
      });
  };

  const genres = new Set<string>();
  books.forEach((b) => {
    if (b.genre) {
      genres.add(b.genre);
    }
  });

  const options = Array.from(genres).map((x) => ({
    key: x,
    text: x,
    value: x,
  }));

  React.useEffect(fetchBooks, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.currentTarget.value);
  };

  const handleAddBook = () => {
    db.collection('books').add({});
    fetchBooks();
  };

  const handleSubmitForm = (newBook: Book) => {
    setBooks((b) => {
      const resp = [...b];
      const index = b.findIndex((x) => x.id === newBook.id);
      if (index >= 0) {
        resp[index] = newBook;
      }
      return resp;
    });
    setEditId(undefined);
  };

  const isGenreSelected = (genre?: string) =>
    (selectedGenres || []).length === 0 ||
    (genre && selectedGenres.includes(genre));

  const handleGenreChange = (event: React.SyntheticEvent, data: any) => {
    setSelectedGenres(data.value);
  };

  const filteredBooks = books.filter((x) => {
    const genreSeleted = isGenreSelected(x.genre);
    const inSearch =
      (x.name || '').toUpperCase().includes((search || '').toUpperCase()) ||
      (x.author || '').toUpperCase().includes((search || '').toUpperCase());
    return genreSeleted && inSearch;
  });

  const admin = isAdmin(user);

  return (
    <Container>
      {admin ? (
        <Menu>
          <Menu.Item name="inventory">
            <Link to="/inventory">Inventory</Link>
          </Menu.Item>
          <Menu.Item name="gallery">
            <Link to="/gallery">Gallery</Link>
          </Menu.Item>

          <Menu.Item name="addBook" onClick={handleAddBook}>
            Add Book
          </Menu.Item>
        </Menu>
      ) : null}
      <div>
        <Input
          fluid
          icon="search"
          value={search}
          onChange={handleSearchChange}
          placeholder="Buscar libro..."
        />
      </div>
      <Segment basic>
        <Dropdown
          clearable
          placeholder="Género"
          fluid
          multiple
          selection
          options={options}
          onChange={handleGenreChange}
        />
      </Segment>
      <Grid>
        {filteredBooks.map((book) => (
          <Segment key={book.id} basic padded>
            {editId === book.id ? (
              <EditBookForm
                key={book.name}
                book={book}
                onSubmitForm={handleSubmitForm}
                onCancel={() => setEditId(undefined)}
              />
            ) : (
              <BookComponent
                key={book.name}
                book={book}
                isAdmin={!!admin}
                onEditClick={() => setEditId(book.id)}
                onDeleteClick={() =>
                  db.collection('books').doc(book.id).delete()
                }
              />
            )}
          </Segment>
        ))}
      </Grid>
    </Container>
  );
};
